import React from 'react';
import './Banner.css';

const Banner = (props) => {
	return (
		<div>
			<div data-content='Investing made natural' className='bannerContainer'>
				<div className='propOverlay'>
				</div>
				<div className='propContainer'>
						<span className='propositionMain'>Investing Made Social</span>
						<span className='propositionSub'>Engage with people you know and trust to ensure your future and fulfill your dreams</span>
						<button type="button" className="btn btn-warning propositionButton" onClick={props.scrollToSocialWall} >Get Started</button>
				</div>
			</div>
		</div>

	);
};

export { Banner };




/** WEBPACK FOOTER **
 ** ./src/common/Banner.js
 **/